import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { axiosProperty, throwResponse } from "config/axios";
import { IDashboardGraph, IDashboardParams } from "../../interface";

export const useGetPropertyDashboardVoting = (
  params?: IDashboardParams
): UseQueryResult<IDashboardGraph[], Error> => {
  return useQuery(
    ["dashboard-property-voting", "count-meeting", params],
    async () => {
      const res = await axiosProperty.get(
        "dashboard/vote-meeting/count-meeting",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};
